// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"k5-z"};